import jwtDecode from 'jwt-decode';

interface JWT {
    nbf: number;
    exp: number;
}

export function validateJWT(token: string): boolean {
    try {
        if (!token) return false;

        const now = new Date().valueOf() / 1000;
        const { nbf: validFrom, exp: expiry } = jwtDecode<JWT>(token);
        const isValid = validFrom < now + 5 && expiry > now;
        return isValid;
    } catch {
        return false;
    }
}

export const getJwtToken = (): string | null => {
    const token = localStorage.getItem('token');
    return token;
};

export const clearJtwtToken = (): void => {
    localStorage.removeItem('token');
};

export const getDecodedJwtToken = (): JWT | null => {
    const token = getJwtToken();
    if (token === null) return null;
    const isValid = validateJWT(token);
    if (!isValid) {
        clearJtwtToken();
        return null;
    }

    const decoded = jwtDecode<JWT>(token);
    return decoded;
};
